/**
 * @generated SignedSource<<b14598e6e29ba4e7759c67bfb497ffd8>>
 * @relayHash e4db664c14f25d2cbd5656b656921164
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionDetailIssueListJiraVersionRefetchQuery$variables = {
  id: string;
  isDevopsFeatureDisabledInFedRamp: boolean;
};
export type versionDetailIssueListJiraVersionRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch">;
  } | null | undefined;
};
export type versionDetailIssueListJiraVersionRefetchQuery = {
  response: versionDetailIssueListJiraVersionRefetchQuery$data;
  variables: versionDetailIssueListJiraVersionRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "versionDetailIssueListJiraVersionRefetchQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "versionDetailIssueListJiraVersionRefetchQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "DevOpsProviders",
                        "kind": "LinkedField",
                        "name": "providers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsFeatureFlagProvider",
                            "kind": "LinkedField",
                            "name": "featureFlagProviders",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraVersion"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc",
    "metadata": {},
    "name": "versionDetailIssueListJiraVersionRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "67e86aee284b1de0db813afbd23b7bbc";

export default node;
